import script from "./HRDiagramPlot.vue?vue&type=script&setup=true&lang=js"
export * from "./HRDiagramPlot.vue?vue&type=script&setup=true&lang=js"

import "./HRDiagramPlot.vue?vue&type=style&index=0&id=45ced109&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45ced109"]])

export default __exports__